import React from 'react'

const Status:React.FC<{status: number}> = ({status}) => {
  const statusMap: { [key: number]: string } = {
    0: 'em aberto',
    1: 'em produção',
    2: 'concluído',
  }
  const colorMap: { [key: number]: string } = {
    0: '#67C97E',
    1: '#FFC107',
    2: '#51A351',
  }
  return (
    <div style={{
      backgroundColor: colorMap[status] ?? '#67C97E',
      color: '#424746',
      padding: '0.5rem',
      borderRadius: '0.5rem',
      marginBottom: '8px',
      textTransform: 'uppercase',
      fontSize: '12px',
      fontWeight: '600',
      width: 'fit-content',
    }}>{statusMap[status] ?? 'em aberto'}</div>
  )
}

export default Status
